export interface FobScannedDto {
	fobId: string;
	scanDate?: Date;
	siteId: number;
}

export class FobScannedDto implements FobScannedDto {
	constructor(data?: Partial<FobScannedDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}